import React from 'react';
import { constSelector, useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent, Grid, MenuItem, TextField } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import { CompanyType } from 'models/CompanyModel';
import auth from 'recoil/atoms/auth';
import companyList from 'recoil/atoms/companyList';
import mainLoadingYardList from 'recoil/selectors/mainLoadingYardList';


type CarDialogProps = {
} & ModalActionProps<{
    chassisNumber: string,
    companyId?: number
    yardId?: number
}>

const CarAddDialog = ({ onFinish }: CarDialogProps) => {
    const {t} = useTranslation('cars');
    const my = useRecoilValue(auth);
    const companies = useRecoilValue(my.type === CompanyType.Shipper ? constSelector([]) : companyList(CompanyType.Shipper));
    const yards = useRecoilValue(mainLoadingYardList);

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const data = new FormData(event.currentTarget);
        const shipper = data.get('companyId');
        const yard = data.get('yardId');
        onFinish({
            chassisNumber: data.get('chassisNumber') as string,
            companyId: shipper ? Number(shipper as string) : undefined,
            yardId: yard ? Number(yard as string) : undefined,
        });
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <TextField
                    id="chassisNumber"
                    name="chassisNumber"
                    label={t('chassis_number')}
                    fullWidth
                    required
                    autoFocus
                />

                {companies.length > 1 && (
                    <Grid item xs={12} sm={3}>
                        <TextField
                            id="companyId"
                            name="companyId"
                            label={t('shipper')}
                            fullWidth
                            select
                        >
                            {companies.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                        </TextField>
                    </Grid>
                )}

                <TextField
                    id="yardId"
                    name="yardId"
                    label={t('yard')}
                    fullWidth
                    select
                    defaultValue={yards.length === 1 ? yards[0].id : undefined}
                >
                    <MenuItem value=""><em>{t('unknown')}</em></MenuItem>
                    {yards.map(c => <MenuItem key={c.id} value={c.id}>{c.port.name} {c.name}</MenuItem>)}
                </TextField>
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('add_car')}</Button>
            </DialogActions>
        </Box>
    );
};

export default CarAddDialog;
